export const iconFontAwesomeNumbers3 = (
	<i className="fa-solid fa-3"></i>
);
